module.exports = __webpack_public_path__ + "static/img/rightlogo.a33a011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/rightlogo.png
// module id = GdNW
// module chunks = 37